import { z } from 'zod';

export const MessageType = z.enum([
  'hide-fab',
  'hide-fab-to-fac',
  'hide-fab-to-fac-transition-complete',
  'hide-fab-transition-complete',
  'hide-fac',
  'hide-fac-transition-complete',
  'hide-support-window',
  'hide-support-window-transition-complete',
  'show-fab',
  'show-fab-to-fac',
  'show-fab-to-fac-transition-complete',
  'show-fab-transition-complete',
  'show-fac',
  'show-fac-transition-complete',
  'show-support-window',
  'show-support-window-transition-complete',
  'show-hidden',
  'show-hidden-transition-complete',
  'simplr-initiate-chat',
  'transition-to-fab',
  'transition-to-fac',
  'transition-to-support-window',
]);
